import { useContext } from "react";

import { TrackingScopeContext, type TrackingScopeValue } from "@/contexts/trackingScopeContext";

/** Reads stable page or section dimensions without exposing the analytics transport. */
export function useTrackingScope(): TrackingScopeValue {
  const scope = useContext(TrackingScopeContext);
  return {
    surface: scope.surface ?? "unknown",
    entityType: scope.entityType,
  };
}
